(function () {
	'use strict';
	angular
		.module('jcsfApp')
		.controller('studentsController', studentsController);

	studentsController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'$filter',
		'$location',
		'events',
		'messaging',
		'authService',
	]; //
	function studentsController(
		$controller,
		$rootScope,
		$scope,
		$filter,
		$location,
		events,
		messaging,
		authService
	) {
		//
		$controller('baseController', { $scope: $scope });
		var vm = this;
		vm.studentLastNameFilter = '';
		vm.errorMessage = '';
		vm.students = [];
		vm.deletedStudents = [];

		vm.orderBy = sessionStorage.getItem('studentsOrderBy') || 'LastName';
		vm.orderByReverse = false;
		vm.setOrderBy = setOrderBy;

		vm.orderByArchive =
			sessionStorage.getItem('studentsArchiveOrderBy') || 'LastName';
		vm.orderByArchiveReverse = false;
		vm.setOrderByArchive = setOrderByArchive;

		vm.archiveStudent = archiveStudent;

		authService.fillAuthData();
		var authentication = authService.authentication;
		activate();
		$scope.subscribe(
			events.message._GET_JCCENTER_LIST_COMPLETE_,
			onGetJcCentersComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_DELETED_LIST_COMPLETE_,
			onGetDeletedStudentsComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_DELETED_LIST_FAILED,
			onGetStudentListFailed
		);
		$scope.subscribe(
			events.message._GET_STUDENT_LIST_COMPLETE_,
			onGetStudentsComplete
		);
		$scope.subscribe(
			events.message._GET_STUDENT_LIST_FAILED,
			onGetStudentListFailed
		);
		$scope.subscribe(events.message._USER_RESPONDED_, function (results) {
			if (results.answer === 'YES') {
				$scope.publish(events.message._DELETE_STUDENT_, [
					{
						id: results.id,
						reason: results.selectreason,
						otherreason: results.reason,
					},
				]);
			}
		});
		vm.searchName = '';
		vm.userJCCCC = authService.authentication.userInfo.JCCCC;
		vm.selectedCenter = authService.authentication.userInfo.JCCCC;
		vm.centers = [];
		vm.centerName = '';

		function activate() {
			if (authentication.userName == null || !authentication.isAuth) {
				$scope.$state.go('home');
			}
			$scope.publish(events.message._GET_JCCENTER_LIST_, []);
		}

		function onGetStudentsComplete(results) {
			vm.students = results;
			vm.deletedStudents = results.filter((x) => x.Deleted > 0);

			if (vm.students == null || vm.students.length === 0) {
				vm.errorMessage = 'No Records Returned';
			}
		}

		function archiveStudent(part) {
			messaging.publish(events.message._DISPLAY_CONFIRMATION_INPUT_, [
				'Are you sure you want to archive ' + part.fullName() + '?',
				'Archive',
				{
					id: part.StudentId,
					/* 10/7/2022 Personal email no longer mandatory*/
					valid: !!part.EducationLevel && !!part.PrimaryPhoneNumber,
				},
			]);
		}

		function onGetJcCentersComplete(results) {
			vm.centers = results;

			if (vm.userJCCCC !== 29) {
				vm.selectedCenter = vm.userJCCCC;
			} else if (
				$rootScope.$stateParams.id !== null &&
				$rootScope.$stateParams.id !== undefined
			) {
				if (vm.userJCCCC !== 29) {
					vm.selectedCenter = vm.userJCCCC;
				} else {
					vm.selectedCenter = $rootScope.$stateParams.id;
				}
			}
			var center = $filter('filter')(vm.centers, {
				CenterId: vm.selectedCenter,
			})[0];
			vm.centerName = center.JCCCC;
			$scope.publish(events.message._GET_STUDENT_LIST_, [
				true,
				vm.selectedCenter,
			]);
		}

		function onGetStudentListFailed(results) {
			vm.errorMessage = '';
			if (vm.errorMessage === '') {
				vm.errorMessage = 'No Records Returned';
			}
		}
		function onGetDeletedStudentsComplete(results) {
			vm.deletedStudents = results;
			if (results == null || results.length === 0) {
				vm.errorMessage = 'No Records Returned';
			}
		}

		/**
		 * @param {string} column
		 */
		function setOrderBy(column) {
			vm.orderByReverse = vm.orderBy === column ? !vm.orderByReverse : false;
			vm.orderBy = column;
			sessionStorage.setItem('studentsOrderBy', column);
		}
		/**
		 * @param {string} column
		 */
		function setOrderByArchive(column) {
			vm.orderByArchiveReverse =
				vm.orderByArchive === column ? !vm.orderByArchiveReverse : false;
			vm.orderByArchive = column;
			sessionStorage.setItem('studentsArchiveOrderBy', column);
		}

		vm.getDeletedStudentList = function (name) {
			vm.deletedtudents = [];
			if (name) {
				vm.errorMessage = '';
				$scope.publish(events.message._GET_STUDENT_DELETED_LIST_, [
					true,
					vm.selectedCenter,
					name,
				]);
			}
		};
		vm.getFullStudentList = function (name) {
			vm.students = [];
			if (name) {
				vm.errorMessage = '';
				$scope.publish(events.message._GET_STUDENT_FULL_LIST_, [true, name]);
			}
		};
		$scope.$watch('vm.selectedCenter', function (value) {
			vm.students = [];
			if ($location.path() !== '/students/archive' && value) {
				vm.errorMessage = '';
				$scope.publish(events.message._GET_STUDENT_LIST_, [
					true,
					vm.selectedCenter,
				]);

				if (vm.centers) {
					var center = $filter('filter')(vm.centers, {
						CenterId: vm.selectedCenter,
					})[0];
					if (center) vm.centerName = center.JCCCC;
				}
			} else {
				vm.centerName = undefined;
			}
		});
	}
})();
